export enum EmailChangeEligibilityReason {
	LOCAL = 'LOCAL',
	DOMAIN_GUEST = 'DOMAIN_GUEST',
	DOMAIN_MANAGED_BY_IDP = 'DOMAIN_MANAGED_BY_IDP',
	TARGET_EMAIL_IN_USE = 'TARGET_EMAIL_IN_USE',
	VERIFICATION_UNAVAILABLE = 'VERIFICATION_UNAVAILABLE',
}

export enum EmailCollisionSide {
	DEALSTACK = 'DEALSTACK',
	WORKOS = 'WORKOS',
	BOTH = 'BOTH',
}

export interface EmailChangeEligibilityView {
	allowed: boolean;
	reason: EmailChangeEligibilityReason;
	domain?: string | null;
	organizationName?: string | null;
	requiresMembershipMove: boolean;
	collidesWith?: EmailCollisionSide | null;
}
